import { useEffect } from 'react';
const FOCUSABLE = 'a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select,[tabindex]:not([tabindex="-1"])';
/** Traps Tab within the panel and closes on Escape — required for the
 *  fullscreen mobile sheet, which is effectively a modal dialog. */
export function useFocusTrap(ref, active, onEscape) {
    useEffect(() => {
        if (!active)
            return;
        const node = ref.current;
        if (!node)
            return;
        const handler = (event) => {
            if (event.key === 'Escape') {
                onEscape?.();
                return;
            }
            if (event.key !== 'Tab')
                return;
            const items = Array.from(node.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
            if (!items.length)
                return;
            const first = items[0];
            const last = items[items.length - 1];
            const activeEl = node.getRootNode().activeElement;
            if (event.shiftKey && activeEl === first) {
                event.preventDefault();
                last.focus();
            }
            else if (!event.shiftKey && activeEl === last) {
                event.preventDefault();
                first.focus();
            }
        };
        node.addEventListener('keydown', handler);
        return () => node.removeEventListener('keydown', handler);
    }, [ref, active, onEscape]);
}
